import "core-js/modules/es6.regexp.match";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.function.name";
import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import _regenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
/**
 * 业务环境上下文管理
 * 提供业务环境状态管理和切换功能
 */
import { createLogger } from "./logger";

// 创建日志记录器
var logger = createLogger('BizContext');
var BizContext = /*#__PURE__*/function () {
  function BizContext() {
    _classCallCheck(this, BizContext);
    this._currentBiz = null;
    this._bizList = [];
    this._subscribers = new Set();
    this._loading = false;
    this._error = null;
    this._initialized = false;
  }

  /**
   * 初始化业务环境
   * @param {Array} [bizList] 业务列表
   * @param {String} [defaultBiz] 默认业务代码
   * @returns {Promise} 初始化Promise
   */
  return _createClass(BizContext, [{
    key: "init",
    value: (function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(bizList, defaultBiz) {
        var _this = this;
        var bizExists;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this._initialized) {
                _context.n = 1;
                break;
              }
              logger.info('Already initialized');
              return _context.a(2, Promise.resolve());
            case 1:
              if (!(Array.isArray(bizList) && bizList.length > 0)) {
                _context.n = 2;
                break;
              }
              logger.info('Initializing with provided business list');

              // 标准化业务列表格式
              this._bizList = this._normalizeBizList(bizList);

              // 设置当前业务代码
              if (defaultBiz) {
                // 检查默认业务代码是否在列表中
                bizExists = this._bizList.some(function (biz) {
                  return (typeof biz === 'string' ? biz : biz.code) === defaultBiz;
                });
                if (bizExists) {
                  this._currentBiz = defaultBiz;
                } else if (this._bizList.length > 0) {
                  // 使用第一个业务的code作为当前业务代码
                  this._currentBiz = typeof this._bizList[0] === 'string' ? this._bizList[0] : this._bizList[0].code;
                }
              } else if (this._bizList.length > 0) {
                // 使用第一个业务的code作为当前业务代码
                this._currentBiz = typeof this._bizList[0] === 'string' ? this._bizList[0] : this._bizList[0].code;
              }
              this._initialized = true;
              this._notify();
              return _context.a(2, Promise.resolve());
            case 2:
              // 否则从API获取业务列表
              logger.info('Fetching business list from API');
              return _context.a(2, this.getBizListFromAPI().then(function (list) {
                _this._bizList = _this._normalizeBizList(list || []);
                logger.info('Business list initialized:', _this._bizList);
                if (_this._bizList.length > 0) {
                  // 使用第一个业务的code作为当前业务代码
                  _this._currentBiz = typeof _this._bizList[0] === 'string' ? _this._bizList[0] : _this._bizList[0].code;
                  logger.info('Current business set to:', _this._currentBiz);
                }
                _this._initialized = true;
                _this._notify();
              }));
          }
        }, _callee, this);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
    /**
     * 标准化业务列表格式
     * 确保业务列表中的每个项目都有统一的格式
     * @param {Array} list 原始业务列表
     * @returns {Array} 标准化后的业务列表
     * @private
     */
    )
  }, {
    key: "_normalizeBizList",
    value: function _normalizeBizList(list) {
      if (!Array.isArray(list)) return [];
      return list.map(function (item) {
        // 如果是字符串，转换为对象格式
        if (typeof item === 'string') {
          return {
            id: item,
            code: item,
            name: item
          };
        } else if (_typeof(item) === 'object' && item !== null) {
          // 如果是对象但缺少必要字段，补充默认值
          return {
            id: item.id || item.code || '',
            code: item.code || item.id || '',
            name: item.name || item.code || item.id || ''
          };
        }
        // 其他情况返回空对象
        return {
          id: '',
          code: '',
          name: ''
        };
      }).filter(function (item) {
        return item.code;
      }); // 过滤掉没有code的项目
    }

    /**
     * 从API获取业务列表
     * @returns {Promise} 业务列表Promise
     */
  }, {
    key: "getBizListFromAPI",
    value: (function () {
      var _getBizListFromAPI = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$import, getMyBizList, res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this._loading) {
                _context2.n = 1;
                break;
              }
              logger.warn('Already loading business list');
              return _context2.a(2, Promise.reject('Already loading'));
            case 1:
              this._loading = true;
              this._error = null;
              this._notify();
              _context2.p = 2;
              _context2.n = 3;
              return import('@/api/cmdb');
            case 3:
              _yield$import = _context2.v;
              getMyBizList = _yield$import.getMyBizList;
              logger.info('Fetching business list from API');
              _context2.n = 4;
              return getMyBizList({
                system: 'job'
              });
            case 4:
              res = _context2.v;
              logger.info('Business list fetched:', res);
              return _context2.a(2, res || []);
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              this._error = _t;
              logger.error('Failed to fetch business list:', _t);
              return _context2.a(2, []);
            case 6:
              _context2.p = 6;
              this._loading = false;
              this._notify();
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 5, 6, 7]]);
      }));
      function getBizListFromAPI() {
        return _getBizListFromAPI.apply(this, arguments);
      }
      return getBizListFromAPI;
    }()
    /**
     * 获取加载状态
     * @returns {Boolean} 是否正在加载
     */
    )
  }, {
    key: "loading",
    get: function get() {
      return this._loading;
    }

    /**
     * 获取错误信息
     * @returns {Error|null} 错误对象
     */
  }, {
    key: "error",
    get: function get() {
      return this._error;
    }

    /**
     * 获取当前业务代码
     * @returns {String|null} 当前业务代码
     */
  }, {
    key: "currentBiz",
    get: function get() {
      return this._currentBiz;
    }

    /**
     * 获取业务列表
     * @returns {Array} 业务列表
     */
  }, {
    key: "bizList",
    get: function get() {
      return _toConsumableArray(this._bizList);
    }

    /**
     * 切换业务环境
     * @param {String} bizCode 目标业务代码
     * @returns {Boolean} 是否切换成功
     */
  }, {
    key: "switchBiz",
    value: function switchBiz(bizCode) {
      if (!bizCode) {
        logger.error('Cannot switch to empty business code');
        return false;
      }
      logger.info("Attempting to switch to business: ".concat(bizCode));

      // 检查业务列表中是否包含该业务代码
      var bizExists = this._bizList.some(function (biz) {
        return (typeof biz === 'string' ? biz : biz.code) === bizCode;
      });
      if (!bizExists) {
        logger.error("Business code ".concat(bizCode, " not found in list:"), this._bizList);
        return false;
      }
      if (this._currentBiz === bizCode) {
        logger.info("Already on business: ".concat(bizCode));
        return true;
      }
      logger.info("Switching from ".concat(this._currentBiz, " to ").concat(bizCode));
      this._currentBiz = bizCode;
      this._notify();
      return true;
    }

    /**
     * 订阅业务环境变更
     * @param {Function} callback 回调函数
     * @returns {Function} 取消订阅函数
     */
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;
      if (typeof callback !== 'function') {
        logger.error('Subscribe callback must be a function');
        return function () {};
      }
      this._subscribers.add(callback);
      return function () {
        return _this2._subscribers.delete(callback);
      };
    }

    // 通知所有订阅者
  }, {
    key: "_notify",
    value: function _notify() {
      var _this3 = this;
      this._subscribers.forEach(function (cb) {
        try {
          cb(_this3._currentBiz);
        } catch (err) {
          logger.error('Error in subscriber callback:', err);
        }
      });
    }
  }]);
}(); // 导出单例实例
export var bizContext = new BizContext();

/**
 * 业务环境Vue插件
 */
export var BizContextPlugin = {
  install: function install(Vue) {
    Vue.prototype.$bizContext = bizContext;
  }
};

/**
 * 从URL中获取业务代码并同步到业务上下文
 * 用于页面刷新时确保业务上下文与URL一致
 */
export function syncBizContextWithUrl() {
  // 如果没有window对象（SSR环境），则直接返回
  if (typeof window === 'undefined') return;

  // 从URL中获取业务代码
  var match = window.location.hash.match(/\/biz\/([^/]+)/);
  var urlBizCode = match ? match[1] : null;
  if (urlBizCode && urlBizCode !== ':biz_code') {
    logger.info("Synchronizing business context with URL: ".concat(urlBizCode));

    // 如果业务上下文已初始化，则直接切换
    if (bizContext._initialized) {
      bizContext.switchBiz(urlBizCode);
    } else {
      // 否则在初始化时设置默认业务代码
      bizContext.init([], urlBizCode).catch(function (err) {
        logger.error('Failed to initialize business context with URL business code:', err);
      });
    }
  } else {
    // 如果URL中没有业务代码，则正常初始化
    if (!bizContext._initialized) {
      bizContext.init().catch(function (err) {
        logger.error('Failed to initialize business context:', err);
      });
    }
  }
}

// 自动初始化
syncBizContextWithUrl();